/**
 * One guide column per ancestor level — 12px on a phone, 20px from `sm` up. A folder row
 * spends its own column on the disclosure arrow, so a file at level 4 lines up exactly
 * under its section's checkbox.
 */
export default function TreeIndent({ level }: { level: number }) {
  const depth = Math.max(0, level - 1);
  if (depth === 0) return null;
  return (
    <>
      {Array.from({ length: depth }).map((_, i) => (
        <span key={i} className="w-3 shrink-0 self-stretch border-l border-gray-200 sm:w-5" aria-hidden="true" />
      ))}
    </>
  );
}
